<script setup>
import { onMounted, onBeforeUnmount, computed, ref, nextTick, watch } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useScrollStore } from "@/stores/storeScroll";
import { useRequestsStore } from "./stores/storeRequests";
import { useFieldsStore } from "./stores/storeFieldData";
import { useRoute, useRouter } from "vue-router";
import TheHeader from "@/components/sections/TheHeader.vue";
import TheFooter from "@/components/sections/TheFooter.vue";
import TheModals from "@/components/blocks/TheModals.vue";
import TheStubPage from "@/pages/TheStubPage.vue";
import BaseCookies from "@/components/blocks/BaseCookies.vue";

const storeSettings = useSettingsStore();
const storeScroll = useScrollStore();
const storeRequests = useRequestsStore();
const storeField = useFieldsStore();
const route = useRoute();

const isStubPage = import.meta.env.VITE_SHOW_STUB === "true";

const isShowMobileMenu = ref(false);

onMounted(async () => {
	
	await nextTick();

	await storeSettings.mainSettings();
	if (storeRequests.isAuthenticated) {
		await storeRequests.userInfo();

		storeField.updateFields("firstName", "disabledBtn", true);
		storeField.updateFields("lastName", "disabledBtn", true);
		storeField.updateFields("phone", "disabledBtn", true);
		storeField.updateFields("email", "disabledBtn", true);
	}

	if (!isStubPage) {
		const params = new URLSearchParams(window.location.search);
		if (params.toString()) {
			localStorage.setItem("registration_params", params.toString());
		}
	}

});

</script>

<template>	
	<div v-if="!isStubPage"  :class="['wrapper']" id="header">
		<TheHeader @mobile-menu-show="isShowMobileMenu = !isShowMobileMenu"/>		
		<main :class="['main', { 'mobile-menu-open': isShowMobileMenu }]" >
			<RouterView />
		</main>
		<TheFooter />
	</div>
	<TheStubPage v-else />
	<BaseCookies v-if="!isStubPage" />
	<TheModals v-if="!isStubPage" />
</template>

<style type="scss" scoped></style>
